import { isPast, isValid } from 'date-fns';

export function isDateValidAndPast(date: Date): boolean {
  return isValid(date) && isPast(date);
}
